import { renderRecaptcha, executeRecaptcha } from './../../helpers/validator'
import { BATCH_FORM_TEMPLATE, FORMS } from './../../helpers/constants'
import { showAlert, initSimilarProductsSwiper, initProductImagesSwiper } from './../../helpers/ir-dom'
import { translate as t } from './../../helpers/string-helpers'

// Batch Quotes from Info Request
export const initBatchQuotesFromIR = () => {
  if (!document.getElementById('batch-quote-form')) return

  const batchQuoteSubmitBtn = document.getElementById('btn-batch-quotes');
  const missingFieldsTooltip = document.querySelector('.message-validation__batch-quotes');
  const $elements = BATCH_FORM_TEMPLATE
    .map(key => window.$('#batch-quote-form').find(`[name='${key}']`));

  batchQuoteSubmitBtn.addEventListener('click', e => {
    e.preventDefault();
    if (e.target.classList.contains('disabled')) {
      missingFieldsTooltip.classList.remove('afd-hide');
      $elements.forEach($field => {
        if ($field[0].tagName === 'SELECT' && !$field.val().trim().length) $field.addClass('bir-select--required');
      });
      return;
    }

    window.ga('send', 'event', 'info-request', 'referred-quote', 'batch-quote');
    executeRecaptcha(FORMS.BATCH_QUOTE);
  });

  $elements.forEach($el => {
    $el.on('input change', e => {
      const { target } = e
      if (target.value.trim().length) target.classList.remove('bir-select--required')
      var shouldDisableBtn = !$elements.every(i => !!i.val().trim().length)
      if (shouldDisableBtn) {
        batchQuoteSubmitBtn.classList.add('disabled')
      } else {
        batchQuoteSubmitBtn.classList.remove('disabled')
        missingFieldsTooltip.classList.add('afd-hide')
      }
    });
  });

  window.$('#batch-quote-form')
    .on('ajax:success', () => {
      batchQuoteSubmitBtn.disabled = true
      batchQuoteSubmitBtn.innerText = t('quote_sent')
    })
    .on('ajax:error', () => {
      showAlert(document.getElementById('info-request-batch'), t('batch_quote_error'), true, true)
    })
    .on('ajax:before ajax:send', () => {
      batchQuoteSubmitBtn.disabled = true
    })

  renderRecaptcha(document.getElementById('batch-quote-recaptcha'), () => window.$('#batch-quote-form').submit(), FORMS.BATCH_QUOTE);
}

// Similar Products section shown on Success Page, either after a single info request or after a Batch Quote from landing
export const initSimilarProductsSection = () => {
  initSimilarProductsSwiper();
  initProductImagesSwiper();

  // Referred Singles Response
  const referredForms = document.querySelectorAll('.referred-quote')
  referredForms.forEach((el, idx) => {
    const productId = el.dataset.product
    window.$(el).on('ajax:success', () => {
      document.querySelectorAll(`.referred-quote[data-product="${productId}"] .bir-cotizar`)
        .forEach(btn => {
          btn.disabled = true;
          btn.innerText = t('quoted')
        });
    }).on('ajax:error', function () {
      const messageWithProduct = t('similar_product_quote_error', { product: this.dataset['title'] })
      showAlert(document.getElementById('info-request-batch'), messageWithProduct, true, true)
    })
  })
  // Attaching GA event to each similar product quote button
  document.querySelectorAll('.bir-cotizar')
    .forEach(btn => {
      btn.addEventListener('click', () => window.ga('send', 'event', 'info-request', 'referred-quote', 'single-quote'))
    })
}

// Skeleton for Batch Quotes Landing
export const setupBatchQuotesSkeleton = () => {
  if (!document.getElementById('batch-landing')) return;

  const skeleton = document.querySelector('.js-batch-examples-skeleton');
  const batchExamples = document.querySelector('.js-batch-examples');

  if (window.device !== 'mobile') {
    const container = document.getElementById('js-batch-examples-container');
    const exampleItems = document.querySelectorAll('.jv-masonry__item');
    const containerHeight = container.offsetHeight;
    container.style.height = `${containerHeight}px`;

    const exampleItemsOffsetTop = Array.from(exampleItems).slice(-3)
      .reduce((acc, item) => [...acc, item.offsetTop + item.offsetHeight], []);

    const newHeight = Math.max(...exampleItemsOffsetTop);
    container.style.height = `${newHeight + 35}px`; // with this 35 we are sure the container height is enough
  }

  skeleton.parentNode.removeChild(skeleton);
  batchExamples.classList.remove('js-batch-examples');
}